import { AfterViewInit, Component, HostListener, ViewEncapsulation } from '@angular/core';
import { setWhiteBackgroundIfNothingSet } from '@modules/cursors/helpers/helpers';

@Component({
  selector: 'app-axis-cursor',
  template: `
    <div class="cursor">
      <div class="axis y"></div>
      <div class="axis x"></div>
    </div>`,
  styles: [`
    body, body * {
      cursor: none !important;
    }

    .cursor .axis,
    app-cursors-wrapper {
      mix-blend-mode: difference;
    }

    .cursor,
    .cursor .axis {
      pointer-events: none;
    }

    .axis.x {
      width: 100vw;
      height: 2px;
    }

    .axis.y {
      width: 2px;
      height: 100vh;
    }

    .cursor .axis {
      background: #fff;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
      transition-duration: 0s !important;
    }
  `],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class AxisCursorComponent implements AfterViewInit {
  private axisX: HTMLElement;
  private axisY: HTMLElement;
  private mouseX = 0;
  private mouseY = 0;

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(e: any): void {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
  }

  ngAfterViewInit(): void {
    setWhiteBackgroundIfNothingSet();
    this.axisX = document.querySelector('.cursor .axis.x') as HTMLElement;
    this.axisY = document.querySelector('.cursor .axis.y') as HTMLElement;

    requestAnimationFrame(() => this.animate());
  }

  private animate(): void {
    if (this.axisX && this.axisY) {
      this.axisX.style.transform = `translateY(${this.mouseY - 1}px`;
      this.axisY.style.transform = `translateX(${this.mouseX - 1}px`;
    }

    requestAnimationFrame(() => this.animate());
  }

}
